import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { authReducer } from './auth';
import { usersReducer } from './users';
import { organizationsReducer } from './organizations';
import { sitesReducer } from './sites';
import { screensReducer } from './screens';
import { filesReducer } from './files';
import { poisReducer } from './pois';
import { categoriesReducer } from './categories';
import { mediaCategoriesReducer } from './mediaCategories';
import { mediaReducer } from './media';
import { preferencesReducer } from './preferences';
import { mapsReducer } from './maps';
import { mapsStaticReducer } from './mapsStatic';
import { feedbackReducer } from './feedback';
import { respondentReducer } from './respondent';
import { screenshotReducer } from './screenshot';
import { informationReducer } from './information';
import { informationCategoriesReducer } from './informationCategories';
import { logsReducer } from './log';
import { tabReducer } from './tab';
import { configReducer } from './config';
import { settingsReducer } from './settings';
import { floorReducer } from './floors';
import { playlistReducer } from './playlist';
import { roleReducer } from './roles';
import { panelReducer } from './panel';
import { menuReducer } from './menu';
import { screenusersReducer } from './screenusers';
import { breadcrumbReducer } from './breadcrumb';
import { templateReducer } from './template';
import { analyticReducer } from './analytic';
import { tagReducer } from './tags';
import { subCategoriesReducer } from './subCategories';
import { mapviewerReducer } from './mapviewer';
import { configsReducer } from './configuration';
import { screenGroupReducer } from './screenGroup';
import { mediaAnalyticsReducer } from './mediaAnalytic';
import { poiDirectoriesReducer } from './poiDirectories';
import { editorsReducer } from './editors';
import sessionReducer from './sessionAnalytic';
import { schedulingReducer } from './scheduling';
import { screenSchedulingReducer } from './screenScheduling';
import { formsReducer } from '@adsign/form-management';
import {
  ticketsReducer,
  chatReducer,
  chatScheduleReducer,
} from '@adsign/ticket-system';
import roomReducer from './room';
import bookingReducer from './booking';
import { webContentsReducer } from './webContents';
import { webPagesReducer } from './webPages';
import { webMenusReducer } from './webMenus';

export default combineReducers({
  auth: persistReducer(
    {
      key: 'auth',
      storage,
      blacklist: ['error', 'loading'],
    },
    authReducer
  ),
  preferences: persistReducer(
    { key: 'preferences', storage },
    preferencesReducer
  ),
  users: persistReducer(
    {
      key: 'users',
      storage,
      blacklist: ['error', 'loading'],
    },
    usersReducer
  ),
  organizations: persistReducer(
    {
      key: 'organizations',
      storage,
      blacklist: ['error', 'loading'],
    },
    organizationsReducer
  ),
  sites: persistReducer(
    {
      key: 'sites',
      storage,
      blacklist: ['error', 'loading'],
    },
    sitesReducer
  ),
  screens: persistReducer(
    {
      key: 'screens',
      storage,
      blacklist: ['error', 'warning'],
    },
    screensReducer
  ),
  files: persistReducer(
    {
      key: 'files',
      storage,
      blacklist: ['error', 'warning'],
    },
    filesReducer
  ),
  scheduling: persistReducer(
    {
      key: 'scheduling',
      storage,
      blacklist: ['error', 'warning'],
    },
    schedulingReducer
  ),
  screenScheduling: persistReducer(
    {
      key: 'screenScheduling',
      storage,
      blacklist: ['error', 'warning'],
    },
    screenSchedulingReducer
  ),
  pois: persistReducer(
    {
      key: 'pois',
      storage,
      blacklist: ['error', 'loading'],
    },
    poisReducer
  ),
  editors: persistReducer(
    {
      key: 'editors',
      storage,
      blacklist: ['error', 'loading'],
    },
    editorsReducer
  ),
  poidirectories: persistReducer(
    {
      key: 'poidirectories',
      storage,
      blacklist: ['error', 'loading'],
    },
    poiDirectoriesReducer
  ),
  categories: persistReducer(
    {
      key: 'categories',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    categoriesReducer
  ),
  mediaCategories: persistReducer(
    {
      key: 'mediaCategories',
      storage,
      blacklist: ['error', 'loading'],
    },
    mediaCategoriesReducer
  ),
  media: persistReducer(
    {
      key: 'media',
      storage,
      blacklist: ['error', 'loading', 'media'],
    },
    mediaReducer
  ),
  maps: persistReducer(
    {
      key: 'maps',
      storage,
      blacklist: ['error', 'loading'],
    },
    mapsReducer
  ),
  mapsStatic: persistReducer(
    {
      key: 'mapStatic',
      storage,
      blacklist: ['error', 'loading'],
    },
    mapsStaticReducer
  ),
  feedback: persistReducer(
    {
      key: 'feedback',
      storage,
      blacklist: ['error', 'loading'],
    },
    feedbackReducer
  ),
  floor: persistReducer(
    {
      key: 'floor',
      storage,
      blacklist: ['error', 'loading'],
    },
    floorReducer
  ),
  respondent: persistReducer(
    {
      key: 'respondent',
      storage,
      blacklist: ['error', 'loading'],
    },
    respondentReducer
  ),
  screenshot: persistReducer(
    {
      key: 'screenshot',
      storage,
      blacklist: ['error', 'loading'],
    },
    screenshotReducer
  ),
  information: persistReducer(
    {
      key: 'information',
      storage,
      blacklist: ['error', 'loading', 'information'],
    },
    informationReducer
  ),
  informationCategories: persistReducer(
    {
      key: 'informationCategories',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    informationCategoriesReducer
  ),
  config: persistReducer(
    {
      key: 'config',
      storage,
      blacklist: ['error', 'loading'],
    },
    configReducer
  ),
  configuration: persistReducer(
    {
      key: 'configuration',
      storage,
      blacklist: ['error', 'loading'],
    },
    configsReducer
  ),
  tags: persistReducer(
    {
      key: 'tags',
      storage,
      blacklist: ['error', 'loading'],
    },
    tagReducer
  ),
  settings: persistReducer(
    {
      key: 'settings',
      storage,
      blacklist: ['error', 'loading'],
    },
    settingsReducer
  ),
  playlist: persistReducer(
    {
      key: 'playlist',
      storage,
      blacklist: ['error', 'loading'],
    },
    playlistReducer
  ),
  logs: persistReducer(
    {
      key: 'logs',
      storage,
      blacklist: ['error', 'loading'],
    },
    logsReducer
  ),
  roles: persistReducer(
    {
      key: 'roles',
      storage,
      blacklist: ['error', 'loading'],
    },
    roleReducer
  ),
  panel: persistReducer(
    {
      key: 'panel',
      storage,
      blacklist: ['error', 'loading'],
    },
    panelReducer
  ),
  toastr: toastrReducer,
  tab: tabReducer,
  breadcrumb: breadcrumbReducer,
  menu: persistReducer(
    {
      key: 'menu',
      storage,
    },
    menuReducer
  ),
  screenusers: persistReducer(
    {
      key: 'screenusers',
      storage,
      blacklist: ['error', 'loading'],
    },
    screenusersReducer
  ),
  template: persistReducer(
    {
      key: 'template',
      storage,
      blacklist: ['error', 'loading'],
    },
    templateReducer
  ),
  analytic: persistReducer(
    {
      key: 'analytic',
      storage,
      blacklist: ['error', 'loading'],
    },
    analyticReducer
  ),
  subcategories: persistReducer(
    {
      key: 'subcategories',
      storage,
      blacklist: ['error', 'loading'],
    },
    subCategoriesReducer
  ),
  mapviewer: persistReducer(
    {
      key: 'mapviewer',
      storage,
      blacklist: ['error', 'loading'],
    },
    mapviewerReducer
  ),
  mediaanalytic: persistReducer(
    {
      key: 'mediaanalytic',
      storage,
      blacklist: ['error', 'loading'],
    },
    mediaAnalyticsReducer
  ),
  screengroup: persistReducer(
    {
      key: 'screengroup',
      storage,
      blacklist: ['error', 'loading'],
    },
    screenGroupReducer
  ),
  ticket: persistReducer(
    {
      key: 'ticket',
      storage,
      blacklist: ['error', 'loading'],
    },
    ticketsReducer
  ),
  chatSchedule: persistReducer(
    {
      key: 'chatSchedule',
      storage,
      blacklist: ['error', 'loading'],
    },
    chatScheduleReducer
  ),
  chat: persistReducer(
    {
      key: 'chat',
      storage,
      blacklist: ['error', 'loading'],
    },
    chatReducer
  ),
  sessionAnalytic: persistReducer(
    {
      key: 'session',
      storage,
      blacklist: [
        'error',
        'loading',
        'pagedList',
        'currentSession',
        'exporting',
        'exportError',
      ],
    },
    sessionReducer
  ),
  form: persistReducer(
    {
      key: 'form',
      storage,
      blacklist: [
        'error',
        'loading',
        'pagedList',
        'currentSession',
        'exporting',
        'exportError',
      ],
    },
    formsReducer
  ),
  room: persistReducer(
    {
      key: 'room',
      storage,
      blacklist: ['error', 'loading'],
    },
    roomReducer
  ),
  booking: persistReducer(
    {
      key: 'booking',
      storage,
      blacklist: ['error', 'loading'],
    },
    bookingReducer
  ),
  webContents: persistReducer(
    {
      key: 'webContents',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    webContentsReducer
  ),
  webPages: persistReducer(
    {
      key: 'webPages',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    webPagesReducer
  ),
  webMenus: persistReducer(
    {
      key: 'webMenus',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    webMenusReducer
  ),
});
